import { ModelBase } from './_model.base.js';

export class Contact extends ModelBase {
	public accountId: string;
	public modelId: string;
	public name: string;
	public title: string;
	public mobilePhone: string;
	public email: string;
}

export class CoOwnerContact extends ModelBase {
	public name: string;
	public modelId: string;
	public email: string;
}
